var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BigBtn"},[_c('div',{staticClass:"btnWrapper"},[_c('a',{style:(_vm.btnStyle),attrs:{"target":"_blank","href":_vm.btnHref}},[_vm._v(_vm._s(_vm.btnText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }